<form [formGroup]="form" class="d-flex flex-column custom-modal-content">
    <div class='my-5'>
            <app-input-field [parentForm]='form' [inputJson]='idFieldObject'>
            </app-input-field>
    </div>
</form>